<template>
  <td :class="wrapperClass" v-on="$listeners">
    <span v-if="disabled" class="ui-state-default" v-text="dayText"></span>
    <a
      v-else-if="!empty"
      class="ui-state-default"
      href="javascript:void(0)"
      @click.prevent.stop="dayClicked(date)"
      v-text="dayText"
    ></a>
  </td>
</template>

<script>
import isSameDay from 'date-fns/isSameDay'
export default {
  name: 'Day',
  props: {
    date: {
      type: Date,
      required: false,
      default: undefined,
    },
    dayNumber: {
      type: Number,
      required: true,
    },
    isWeekend: {
      type: Boolean,
      default: false,
    },
    minEnableDate: {
      type: Date,
      required: true,
    },
    maxEnableDate: {
      type: Date,
      required: true,
    },
    startingDate: {
      type: Date,
      default: null,
    },
    endingDate: {
      type: Date,
      default: null,
    },
    hoveringDate: {
      type: Date,
      default: null,
    },
    range: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    empty() {
      return this.dayNumber === -1
    },
    dayText() {
      return this.empty ? ' ' : this.dayNumber
    },
    disabled() {
      // disable if before min date or after max date
      return (
        !this.empty &&
        (this.date < this.minEnableDate || this.date > this.maxEnableDate)
      )
    },
    wrapperClass() {
      const cls = this.isWeekend ? 'ui-datepicker-week-end ' : ''
      if (this.empty) {
        return (
          cls +
          'ui-datepicker-other-month ui-datepicker-unselectable ui-state-disabled'
        )
      }
      if (this.disabled) {
        return cls + 'ui-datepicker-unselectable ui-state-disabled'
      }
      // selected
      if (
        isSameDay(this.startingDate, this.date) ||
        (this.range && isSameDay(this.endingDate, this.date))
      ) {
        return cls + 'selected ui-datepicker-current-day'
      }
      if (this.range) {
        if (
          // between selected days
          (this.startingDate !== null &&
            this.endingDate !== null &&
            this.date > this.startingDate &&
            this.date < this.endingDate) || // hovered
          (this.startingDate !== null &&
            this.endingDate === null &&
            this.date > this.startingDate &&
            this.date <= this.hoveringDate)
        ) {
          return cls + 'between'
        }
      }
      return cls
    },
  },
  methods: {
    dayClicked() {
      this.$emit('day-clicked', { date: this.date })
    },
  },
}
</script>

<style scoped lang="scss">
.ui-state-default {
  color: #333333 !important;
}
.ui-datepicker-unselectable.ui-state-disabled .ui-state-default {
  color: #B4B4B4 !important;
}
.selected.ui-datepicker-current-day .ui-state-default {
  color: white !important;
}
</style>
